/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-nested-ternary */
import Button from '@brands/Components/Button/Button';
import SelectInput from '@brands/Components/Inputs/SelectInput/SelectInput';
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import PhiDisclaimerFooter from '@brands/Components/PhiDisclaimerFooter/PhiDisclaimerFooter';
import LinearProgressDisplay from '@brands/Components/ProgressDisplay/ProgressDisplay';
import BrandLogo from '@brands/Components/BrandLogo/BrandLogo';
import closeIcon from '@brands/Components/PatientIntakeNavigation/Icons/patientIntakeNavigationClose.svg';
import intakeLogo from '@brands/Components/PatientIntakeNavigation/Icons/patientIntakeNavigationLogo.svg';
import AbandonIntakeProcessModal from '@brands/Components/PatientIntakeNavigation/Modal/AbandonIntakeProcessModal';
import { config } from '@brands/config/config';
import OpenCaseListModal from '@brands/Dashboard/Dashboard/Components/OpenCaseListModal/OpenCaseListModal';
import SubmitCCConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitCCConfirmationModal';
import { useAppDispatch, useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { CasePayload, createNewCase } from '@brands/services/cases/createNewCase';
import { isStartableCaseType } from '@brands/services/cases/retiredCaseTypes';
import { IListCases, listAllCases } from '@brands/services/cases/listAllCases';
import { CaseType, ICase } from '@brands/services/cases/types/ICase';
import { Pricings } from '@brands/services/identity/getPricings';
import { getPricingsByAdmin } from '@brands/services/identity/getPricingsByAdmin';
import { getUserAvatar } from '@brands/services/identity/getUserAvatar';
import { getUserById } from '@brands/services/identity/getUserById';
import { listAllOrganizations } from '@brands/services/identity/listAllOrganizations';
import { Organization, UserProfile, UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectClientBranding } from '@brands/store/selectors/clientBranding';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setPatientState } from '@brands/store/slices/currentPatientState';
import { setOrganizationPrices } from '@brands/store/slices/organizationPricingSlice';
import { setOrganization } from '@brands/store/slices/organizationSlice';
import { setNotInvitedPatientId, setStaffIntakeInProgress } from '@brands/store/slices/staffCaseCreationSlice';
import { setDependentId, setIsFromSelectPatient } from '@brands/store/slices/pageStateSlice';
import {
  FormValues,
  setExternalForms,
  setForm,
  setSelectedPatient as setSelectedPatientForm,
} from '@brands/store/slices/patientFormSlice';
import { setSelectedPatientByAdmin } from '@brands/store/slices/selectedPatientSlice';
import { checkExternalFormAnswers } from '@brands/Utils/checkExternalForms';
import { selectCommonCustomStylesSlim } from '@brands/Utils/customStyles';
import { isUnifiedStaffCaseIntakeRole } from '@brands/Utils/reviewProfileBasePath';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { getFriendlyName } from '@brands/Utils/getFriendlyName';
import { Option, stateOptions } from '@brands/Utils/selectOptions';
import InfoIcon from '@mui/icons-material/Info';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import type { GroupBase, StylesConfig } from 'react-select';
import { getStaffReviewProfileBasePath } from '@brands/Utils/reviewProfileBasePath';
import { useNavigate, useParams } from 'react-router-dom';

import Container from '@brands/Components/Container/Container';
import caLayoutStyles from '@brands/Dashboard/Dashboard/CareAdvisor/careAdvisorDashboard.module.scss';
import styles from './styles.module.scss';
import { uploadMediaToCase } from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';
import { selectIsFromHandOff } from '@brands/store/selectors/isFromHandOff';
import { completeMobileHandoff } from '@brands/services/communication/completeMobileHandover';
import { setIsFromHandoff } from '@brands/store/slices/isFromHandOffSlice';

const COLLECTOR_CASE_CREATION_PROGRESS = 50;

type CollectorCaseCreationLayoutProps = {
  children: React.ReactNode;
  progress: number;
  onExit: () => void;
};

const CollectorCaseCreationLayout: React.FC<CollectorCaseCreationLayoutProps> = ({ children, progress, onExit }) => {
  const [displayAbandonIntakeProcessModal, setDisplayAbandonIntakeProcessModal] = useState(false);
  const clientBranding = useAppSelector(selectClientBranding);

  return (
    <div className={styles.collectorCcFullPage}>
      <header className={styles.caseCreationIntakeHeader}>
        <div className={styles.caseCreationIntakeHeaderTop}>
          <BrandLogo
            customLogoUrl={clientBranding?.logo_url}
            fallbackLogo={intakeLogo}
            className={styles.caseCreationIntakeLogo}
          />
          <button
            type="button"
            onClick={() => setDisplayAbandonIntakeProcessModal(true)}
            className={styles.caseCreationIntakeCloseIcon}
            aria-label="Close and exit"
          >
            <img src={closeIcon} alt="" />
          </button>
        </div>
        <LinearProgressDisplay progress={progress} />
      </header>
      <main className={styles.collectorCcMain}>
        <div className={styles.collectorCcMainContent}>{children}</div>
        <PhiDisclaimerFooter />
      </main>
      {displayAbandonIntakeProcessModal && (
        <AbandonIntakeProcessModal
          setDisplayAbandonIntakeProcessModal={setDisplayAbandonIntakeProcessModal}
          onConfirmExit={onExit}
        />
      )}
    </div>
  );
};

type CaseOption = {
  case_type: string;
  amount: number;
  payment_options?: string[];
  amount_after_plan?: number;
  plan_decision_reason?: string | null;
  plan_free_remaining?: number | null;
};

const CreateConsultationFor = (): JSX.Element => {
  const navigate = useNavigate();
  const baseRoleNavigate = useRoleNavigate();
  const dispatch = useAppDispatch();
  const { userId, targetRole, role: _role } = useParams<{ userId: string; targetRole?: string; role?: string }>();
  const routeRole = targetRole ?? _role;
  const { userInfo } = useAppSelector(selectAuth);

  /** Staff base path from signed-in role (not URL), so collector back nav never lands on `/admin/review-profile`. */
  const reviewProfileBasePath = getStaffReviewProfileBasePath(userInfo.role.name);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const { selectedPatient } = useAppSelector(selectPatient);
  const selectedPatientUserId = selectedPatient?.id;
  const [submitCCConfirmation, setSubmitCCConfirmation] = useState(false);
  const { selectedPatient: currentPatient, values } = useAppSelector(selectPatientForm);
  const [allOrganization, setAllOrganization] = useState<Organization[]>([]);
  const [customizeUserOrganization, setCustomizaUserOrganization] = useState<Organization[]>([]);
  const [organizationOptions, setOrganizationOptions] = useState<Option[]>([]);
  const [loadingCalculation, setLoadingCalculation] = useState(false);
  const [loadingUntillGetUserInfo, setLoadingUntillGetUserInfo] = useState(true);
  const currentState: string = useAppSelector(selectCurrentPatientState);

  const [hasSelectedPatientLocationState, setHasSelectedPatientLocationState] = useState(false);
  const [selectedState, setSelectedState] = useState(
    selectedPatient?.id
      ? currentState[selectedPatient.id] || selectedPatient?.address?.state
      : selectedPatient?.address?.state,
  );
  const [selectedOrganization, setSelectedOrganization] = useState('');
  const [selectedCase, setSelectedCase] = useState({
    selectedCaseType: '',
    selectedCasePrice: '',
  });
  const [caseOptions, setCaseOptions] = useState<CaseOption[]>([]);
  const [pharmacyAddress, setPharmacyAddress] = useState<string>('');
  const [openCases, setOpenCases] = useState<ICase[]>([]);
  const [openCasesModal, toggleOpenCasesModal] = useState<string | null>(null);
  const [orgId, setOrgId] = useState('');

  const isFromHandoffMobile = useAppSelector(selectIsFromHandOff);

  const isCurrentUserAdmin = useMemo(() => {
    return (
      userInfo.role.name === UserRoleName.Admin ||
      userInfo.role.name === UserRoleName.SuperAdmin ||
      userInfo.role.name === UserRoleName.OrganizationAdmin
    );
  }, [userInfo.role.name]);

  const completeMobileHandoffFn = async (): Promise<void> => {
    try {
      await completeMobileHandoff();
      dispatch(setIsFromHandoff(false));
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  /** Admin, cli admin, Collector, or Care Advisor creating a case on behalf of a patient (same payload paths as admin). */
  const isStaffCaseCreation = useMemo(
    () =>
      isCurrentUserAdmin ||
      userInfo.role.name === UserRoleName.Collector ||
      userInfo.role.name === UserRoleName.CareAdvisor,
    [isCurrentUserAdmin, userInfo.role.name],
  );

  const isCollectorCaseCreation = userInfo.role.name === UserRoleName.Collector;
  const selectedPatientLocationState =
    selectedState ||
    (selectedPatient?.id ? currentState[selectedPatient.id] : '') ||
    selectedPatient?.address?.state ||
    '';

  useEffect(() => {
    setHasSelectedPatientLocationState(false);
    setSelectedState('');
  }, [selectedPatient?.id]);

  useEffect(() => {
    if (hasSelectedPatientLocationState) return;

    const nextState =
      (selectedPatient?.id ? currentState[selectedPatient.id] : '') || selectedPatient?.address?.state || '';

    if (nextState && nextState !== selectedState) {
      setSelectedState(nextState);
    }
  }, [
    currentState,
    hasSelectedPatientLocationState,
    selectedPatient?.address?.state,
    selectedPatient?.id,
    selectedState,
  ]);

  const usesUnifiedStaffIntakeRouting = useMemo(
    () => isUnifiedStaffCaseIntakeRole(userInfo.role.name),
    [userInfo.role.name],
  );
  const isUnifiedStaffIntakeMode = usesUnifiedStaffIntakeRouting;

  const identityApiRoleForUserFetch = useMemo((): UserRoleName | undefined => {
    if (userInfo.role.name === UserRoleName.Collector || userInfo.role.name === UserRoleName.CareAdvisor) {
      return userInfo.role.name;
    }
    return undefined;
  }, [userInfo.role.name]);

  const roleNavigateWithStaffIntake = useCallback(
    (to: string, options?: { replace?: boolean; state?: unknown }) => {
      if (usesUnifiedStaffIntakeRouting) {
        dispatch(setStaffIntakeInProgress(true));
      }
      baseRoleNavigate(to, options);
    },
    [baseRoleNavigate, dispatch, usesUnifiedStaffIntakeRouting],
  );

  const collectorStateSelectStyles = useMemo((): StylesConfig<Option, false, GroupBase<Option>> => {
    const slim = selectCommonCustomStylesSlim;
    return {
      ...slim,
      control: (provided, state) => {
        const base = typeof slim.control === 'function' ? slim.control(provided, state) : provided;
        return {
          ...base,
          minHeight: 56,
          border: '1px solid rgba(0, 0, 0, 0.23)',
          borderRadius: 4,
          boxShadow: state.isFocused ? base.boxShadow : 'none',
        };
      },
      valueContainer: (provided, state) => {
        const base = typeof slim.valueContainer === 'function' ? slim.valueContainer(provided, state) : provided;
        return { ...base, fontSize: 16, paddingTop: 4, paddingBottom: 4 };
      },
      placeholder: (provided, state) => {
        const base = typeof slim.placeholder === 'function' ? slim.placeholder(provided, state) : provided;
        return { ...base, color: 'rgba(13, 32, 53, 0.38)' };
      },
      singleValue: (provided, state) => {
        const base = typeof slim.singleValue === 'function' ? slim.singleValue(provided, state) : provided;
        return { ...base, color: 'rgba(13, 32, 53, 0.6)' };
      },
      dropdownIndicator: (provided, state) => {
        const base = typeof slim.dropdownIndicator === 'function' ? slim.dropdownIndicator(provided, state) : provided;
        return {
          ...base,
          backgroundColor: 'transparent',
          color: 'rgba(23, 36, 51, 0.87)',
          borderRadius: 0,
        };
      },
    };
  }, []);

  const handleCollectorExit = useCallback(() => {
    dispatch(setStaffIntakeInProgress(false));
    baseRoleNavigate('/dashboard');
  }, [baseRoleNavigate, dispatch]);

  const organizationPrices = useAppSelector(selectOrganizationPrices);

  const fetchOrganizationOptions = async (): Promise<void> => {
    try {
      setLoadingUntillGetUserInfo(true);
      const data = await listAllOrganizations(
        userInfo.role.name === UserRoleName.Collector || userInfo.role.name === UserRoleName.CareAdvisor
          ? userInfo.role.name
          : undefined,
      );
      setAllOrganization(data.nodes);
      let nodes = data.nodes;
      if (userInfo.role.name === UserRoleName.OrganizationAdmin) {
        const orgId = userInfo.organizations?.[0]?.id;
        nodes = orgId ? nodes.filter((org) => org.id === orgId) : [];
      }
      const transformedData = nodes.map((organization: Organization) => ({
        value: organization.id,
        label: organization.name,
        id: organization.id,
      }));
      setOrganizationOptions(transformedData);
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
    setLoadingUntillGetUserInfo(false);
  };

  const createCaseForThisRequirement = async (): Promise<ICase> => {
    setLoadingCalculation(true);
    const payload: CasePayload = {
      type: 'care_coordination',
      status: 'new',
      patient_id: isStaffCaseCreation
        ? selectedPatient.guardian_id == null
          ? selectedPatient?.id
          : selectedPatient.guardian_id!
        : Number(userInfo.id),
      organization_id: currentOrganization?.id || 'dentistry-one',
      provider_id: undefined,
      payment_profile_id: null,
      video_conference_date: null,
      patient_current_state: isStaffCaseCreation ? selectedPatientLocationState : currentState[userInfo.id] || '',
      dependent_id: isStaffCaseCreation
        ? selectedPatient.guardian_id == null
          ? null
          : Number(currentPatient?.id)
        : Number(selectedPatient?.value) !== Number(userInfo.id)
        ? Number(selectedPatient?.value)
        : null,
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      license_states: isStaffCaseCreation ? [selectedPatientLocationState] : [currentState[userInfo.id]],
      case_intake_questions: {
        is_dental_emergency: values.find((item) => item.form_question_id === 15)?.value.dental_emergency === 'yes',
        in_pain: values.find((item) => item.form_question_id === 16)?.value.inPain === 'yes',
        pain_description: (values.find((item) => item.form_question_id === 16)?.value.describePain as string[]) || [],
        pain_time: (values.find((item) => item.form_question_id === 16)?.value.daysInPain as string) || '',
        pain_level: (values.find((item) => item.form_question_id === 16)?.value.painLevel as string) || '',
        additional_info: (values.find((item) => item.form_question_id === 18)?.value.anythingElse as string) || '',
      },
    };
    const caseRes = await createNewCase(payload, userInfo.role.name);
    if (isFromHandoffMobile) {
      await completeMobileHandoffFn();
    }

    const imagesValue = values.find((item) => item.form_question_id === 17)?.value.images;
    if (Array.isArray(imagesValue)) {
      await uploadMediaToCase(caseRes, imagesValue, userInfo.role.name);
    }
    setLoadingCalculation(false);
    return caseRes;
  };

  useEffect(() => {
    if (!selectedPatient && userId) {
      const fetchPatient = async (): Promise<void> => {
        try {
          const patient = await getUserById(Number(userId), identityApiRoleForUserFetch);
          dispatch(setSelectedPatientByAdmin({ selectedPatient: patient }));
          dispatch(
            setSelectedPatientForm({
              value: patient.id.toString(),
              label: patient.full_name,
            }),
          );
        } catch (error) {
          displayErrorDetails(error);
        }
      };
      fetchPatient();
    }
  }, [selectedPatientUserId, userId, identityApiRoleForUserFetch]);

  useEffect(() => {
    if (isStaffCaseCreation && selectedPatientUserId) fetchOrganizationOptions();
  }, [selectedPatientUserId]);

  const calculateCreateCaseOption = async (organizationId: string, selectedStateTest: string): Promise<void> => {
    setLoadingCalculation(true);
    try {
      let patientRequistOrganization: any;
      if (organizationId !== '') {
        patientRequistOrganization = allOrganization?.find(
          (patientOrganization: Organization) => patientOrganization.id === organizationId,
        );
      }

      const pricings = await getPricingsByAdmin(Number(selectedPatient.id), organizationId, {
        userRole: userInfo.role.name,
      });

      dispatch(setOrganization({ currentOrganization: patientRequistOrganization! }));
      dispatch(setOrganizationPrices({ currentOrganizationPrices: pricings }));

      const caseTypeOptions: CaseOption[] = [];

      pricings.forEach((selectedOrganizationPrice) => {
        const filteredCaseTypes = selectedOrganizationPrice.case_types.filter((caseType) => {
          const org = allOrganization.find(
            (selectedPatientOrganization) => selectedPatientOrganization.id === organizationId,
          );
          const pc = org?.professional_corporations?.find((selectedPC) => selectedPC.state === selectedStateTest);

          return (
            isStartableCaseType(caseType) &&
            ((pc?.video_case_enabled && caseType.startsWith('video_call')) ||
              (pc?.async_case_enabled &&
                (caseType === CaseType.one_report || caseType === CaseType.clinical_enablement)) ||
              (pc?.phone_case_enabled && caseType === 'phone_call_scheduled') ||
              caseType === CaseType.care_coordination ||
              caseType === CaseType.oral_health_coaching ||
              (pc?.second_opinion_case_enabled && caseType === 'second_opinion'))
          );
        });

        filteredCaseTypes.forEach((caseType) => {
          caseTypeOptions.push({
            case_type: caseType,
            amount: selectedOrganizationPrice.amount,
            payment_options: selectedOrganizationPrice.payment_options ?? [],
            amount_after_plan: selectedOrganizationPrice.amount_after_plan,
            plan_decision_reason: selectedOrganizationPrice.plan_decision_reason,
            plan_free_remaining: selectedOrganizationPrice.plan_free_remaining,
          });
        });
      });

      setCaseOptions(caseTypeOptions);
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      setLoadingCalculation(false);
    }
  };

  useEffect(() => {
    if (!isUnifiedStaffIntakeMode) return;
    if (!selectedOrganization || selectedState === '' || selectedState === undefined || selectedState === null) return;
    void calculateCreateCaseOption(selectedOrganization, selectedState as string);
  }, [isUnifiedStaffIntakeMode, selectedOrganization, selectedState]);

  useEffect(() => {
    if (selectedPatient) {
      if (userInfo.role.name === UserRoleName.Admin || userInfo.role.name === UserRoleName.SuperAdmin) {
        setCustomizaUserOrganization(selectedPatient.organizations ?? []);
      } else if (userInfo.role.name === UserRoleName.OrganizationAdmin) {
        const orgs = selectedPatient.organizations ?? [];
        setCustomizaUserOrganization([
          orgs.find(
            (superAdminOrganization: Organization) => superAdminOrganization.id === userInfo.organizations?.[0]?.id,
          ) || orgs[0],
        ]);
      } else if (userInfo.role.name === UserRoleName.CareAdvisor) {
        setCustomizaUserOrganization(selectedPatient.organizations ?? []);
      } else if (userInfo.role.name === UserRoleName.Collector) {
        const fromPatient = selectedPatient.organizations ?? [];
        if (fromPatient.length > 0) {
          setCustomizaUserOrganization(fromPatient);
        } else if (selectedOrganization && allOrganization.length > 0) {
          const o = allOrganization.find((x) => x.id === selectedOrganization);
          setCustomizaUserOrganization(o ? [o] : []);
        } else {
          setCustomizaUserOrganization([]);
        }
      }
      setPharmacyAddress(
        [
          selectedPatient?.pharmacy_street_address,
          selectedPatient?.pharmacy_city,
          selectedPatient?.pharmacy_state,
          selectedPatient?.pharmacy_zip_code,
        ]
          .filter(Boolean)
          .join(', '),
      );
    }
  }, [selectedPatient, userInfo.role.name, userInfo.organizations, selectedOrganization, allOrganization]);

  useEffect(() => {
    if (!isUnifiedStaffIntakeMode || allOrganization.length === 0) return;

    const pickOrgId = (): string => {
      const fromPatient = customizeUserOrganization;
      if (fromPatient.length === 1) return fromPatient[0].id;
      if (fromPatient.length > 1) {
        return fromPatient.find((o) => o.id === 'dentistry-one')?.id ?? fromPatient[0].id;
      }
      const staffOrg = userInfo.organizations?.[0]?.id;
      if (staffOrg) return staffOrg;
      return config.organization_id || '';
    };

    const next = pickOrgId();
    if (next && next !== selectedOrganization) {
      setSelectedOrganization(next);
    }
  }, [
    isUnifiedStaffIntakeMode,
    allOrganization.length,
    customizeUserOrganization,
    userInfo.organizations,
    selectedOrganization,
  ]);

  const checkExternalForms = async (): Promise<string[]> => {
    let patient = selectedPatient as UserProfile | undefined;
    if (isStaffCaseCreation && patient?.id != null) {
      patient = await getUserById(Number(patient.id), identityApiRoleForUserFetch);
      dispatch(setSelectedPatientByAdmin({ selectedPatient: patient }));
    }
    if (patient == null) {
      dispatch(setNotInvitedPatientId(null));
      dispatch(setExternalForms([]));
      return [];
    }

    let guardianResponse;
    const guardianId = patient.guardian_id;
    if (guardianId != null) {
      guardianResponse = await getUserById(Number(guardianId), identityApiRoleForUserFetch);
    }

    // A patient who was never invited (for a dependent, whose guardian was
    // never invited) is cared for by the client in-house, so staff may skip
    // their medical and dental history during the intake.
    const isNotInvited = (guardianResponse ?? patient).status === 'Not Invited';
    dispatch(setNotInvitedPatientId(isStaffCaseCreation && isNotInvited ? Number(patient.id) : null));

    const [checkProfile, checkMedicalHistory, checkMedicalConditionsFormAnswer, checkDentalHistoryFormAnswer] =
      await checkExternalFormAnswers(guardianResponse ?? patient, patient, userInfo.role.name);
    const formsToSet = [];
    if (!checkProfile) formsToSet.push('patient_profile');
    if (!checkMedicalHistory) formsToSet.push('patient_medical_history');
    if (!checkMedicalConditionsFormAnswer) formsToSet.push('patient_medical_conditions');
    if (!checkDentalHistoryFormAnswer) formsToSet.push('patient_dental_history');

    dispatch(setExternalForms(formsToSet));
    return formsToSet;
  };

  const getOpenCases = async (): Promise<IListCases> => {
    const openCaseParams = {
      sort_by: 'created_at' as const,
      sort_direction: 'desc' as const,
      patient_id: Number(selectedPatient?.id),
      status: [
        'new',
        'accepted_care_advisor',
        'accepted_provider',
        'in_progress_provider',
        'in_progress_care_advisor',
        'completed_by_provider',
      ],
      type: [
        CaseType.one_report,
        CaseType.second_opinion,
        CaseType.video_call_scheduled,
        CaseType.phone_call_scheduled,
        CaseType.care_coordination,
        CaseType.clinical_enablement,
      ],
      limit: 100,
      include_dependents_cases: false,
    };

    const queryStr = await Promise.all(
      Object.keys(openCaseParams).map((key) => {
        const value = openCaseParams[key as keyof typeof openCaseParams];
        if (Array.isArray(value)) {
          return value.map((v) => `${key}=${v}`).join('&');
        }
        return `${key}=${value}`;
      }),
    );

    const openCaseList = await listAllCases(queryStr.join('&'));

    await Promise.all(
      (openCaseList.nodes = openCaseList.nodes.reduce((acc: ICase[], current: ICase) => {
        if (
          (current.type === 'video_call_scheduled' || current.type === 'phone_call_scheduled') &&
          (current.status === 'in_progress_provider' || current.status === 'in_progress_care_advisor')
        ) {
          return acc;
        }
        return [...acc, current];
      }, [])),
    );
    return openCaseList;
  };

  const selectCaseType = async (
    organizationId: string,
    option: {
      selectedCaseType: string;
      selectedCasePrice: string;
    },
    getCases = true,
  ): Promise<void> => {
    if (selectedPatient?.id && selectedPatientLocationState) {
      dispatch(setPatientState({ userId: selectedPatient.id, state: selectedPatientLocationState }));
    }
    if (getCases) {
      const { nodes: openCaseList } = await getOpenCases();
      if (openCaseList?.length > 0) {
        setOpenCases(openCaseList);
        toggleOpenCasesModal(option.selectedCaseType);
        setOrgId(organizationId);
        return;
      }
    }

    setLoadingUntillGetUserInfo(true);
    const currentOrganizationPrices = organizationPrices?.currentOrganizationPrices.find(
      (currentOrganizationPrise: Pricings) => currentOrganizationPrise.case_types.includes(option.selectedCaseType),
    );

    const data = await checkExternalForms();
    // Every staff role, admins included, sees the patient's profile step when
    // anything on it is missing. For admins the profile form itself decides
    // what is required: a patient who was never invited to the platform only
    // needs name and date of birth (plus the guardian relationship for a
    // dependent), an invited one needs the full profile.
    const isProfileDataAvailable = data.length !== 0 && data.includes('patient_profile');
    /** Staff: incomplete patient profile → review profile first, then resume intake (e.g. payment-information). */
    if (isProfileDataAvailable) {
      dispatch(setIsFromSelectPatient(true));
      dispatch(setDependentId(selectedPatient?.guardian_id != null ? selectedPatient.id.toString() : null));

      if (
        option.selectedCaseType === 'video_call_instant' ||
        option.selectedCaseType === 'video_call_scheduled' ||
        option.selectedCaseType === 'one_report' ||
        option.selectedCaseType === CaseType.care_coordination ||
        option.selectedCaseType === CaseType.oral_health_coaching ||
        option.selectedCaseType === CaseType.phone_call_scheduled ||
        option.selectedCaseType === CaseType.clinical_enablement
      ) {
        const formPayload: FormValues[] = [
          {
            form_question_id: 20,
            value: { caseType: option.selectedCaseType },
          },
        ];
        dispatch(setForm(formPayload));
      } else if (option.selectedCaseType === 'second_opinion') {
        const formPayload: FormValues[] = [
          {
            form_question_id: 15,
            value: {
              dental_emergency: 'no',
              sensitive_teeth: 'no',
              second_opinion: 'yes',
              improve_smile: 'no',
              improve_gum_health: 'no',
              grind_teeth_or_snore: 'no',
              something_else: 'no',
            },
          },
          {
            form_question_id: 16,
            value: { inPain: 'no', describePain: ['dull'], painLevel: 'noPain', daysInPain: '' },
          },
          { form_question_id: 20, value: { caseType: 'second_opinion' } },
        ];
        dispatch(setForm(formPayload));
      }
      if (selectedPatient.guardian_id != null) {
        navigate(`${reviewProfileBasePath}/Dependent/${selectedPatient.id}`, {
          state: { caseType: option.selectedCaseType },
        });
        return;
      }
      navigate(`${reviewProfileBasePath}/Patient/${selectedPatient.id}`, {
        state: { caseType: option.selectedCaseType },
      });
      return;
    }
    const isPaymentRequired = Number(option.selectedCasePrice) > 0;

    // Collector, admin, cli admin, and care advisor: same unified routing as collector (payment-first where applicable).
    if (usesUnifiedStaffIntakeRouting && option.selectedCaseType !== CaseType.care_coordination) {
      const ct = option.selectedCaseType;

      let formPayload: FormValues[];
      if (ct === 'second_opinion') {
        formPayload = [
          {
            form_question_id: 15,
            value: {
              dental_emergency: 'no',
              sensitive_teeth: 'no',
              second_opinion: 'yes',
              improve_smile: 'no',
              improve_gum_health: 'no',
              grind_teeth_or_snore: 'no',
              something_else: 'no',
            },
          },
          {
            form_question_id: 16,
            value: { inPain: 'no', describePain: ['dull'], painLevel: 'noPain', daysInPain: '' },
          },
          { form_question_id: 20, value: { caseType: 'second_opinion' } },
        ];
      } else {
        formPayload = [{ form_question_id: 20, value: { caseType: ct } }];
      }
      dispatch(setForm(formPayload));

      const navState = {
        caseType: ct,
        userOrganization: selectedOrganization,
        patientId: selectedPatient?.id,
        patientState: selectedPatientLocationState,
      };

      let nextRoute: string;
      switch (ct) {
        case CaseType.video_call_scheduled:
        case CaseType.phone_call_scheduled:
          nextRoute = '/select-provider';
          break;
        case CaseType.oral_health_coaching:
          nextRoute = '/select-care-advisor';
          break;
        case CaseType.video_call_instant:
          nextRoute = '/select-needs';
          break;
        case CaseType.second_opinion:
          if (userInfo.role.name === UserRoleName.Admin) {
            nextRoute = '/select-pharmacy';
          } else {
            nextRoute = '/clinical-data';
          }
          break;
        case CaseType.one_report:
          if (userInfo.role.name === UserRoleName.Admin) {
            nextRoute = '/select-pharmacy';
          } else {
            nextRoute = '/clinical-data';
          }
          break;
        case CaseType.clinical_enablement:
          // Photos come before the medical-history questionnaire for this
          // case type only, so those steps can tell whether a file was
          // already attached and relax their required fields accordingly.
          nextRoute = '/upload-image';
          break;
        case CaseType.care_coordination:
          if (userInfo.role.name === UserRoleName.Admin) {
            nextRoute = '/payment-information';
          } else {
            nextRoute = '/clinical-data';
          }
          break;
        default:
          if (userInfo.role.name === UserRoleName.Admin) {
            nextRoute = '/describe-pain-level';
          } else {
            nextRoute = '/clinical-data';
          }
          break;
      }

      roleNavigateWithStaffIntake(nextRoute, { state: navState });
      setLoadingUntillGetUserInfo(false);
      return;
    }

    if (
      customizeUserOrganization.length > 1 &&
      option.selectedCaseType !== '' &&
      organizationId !== '' &&
      userInfo.role.name !== UserRoleName.OrganizationAdmin
    ) {
      if (
        option.selectedCaseType === 'video_call_instant' ||
        option.selectedCaseType === 'video_call_scheduled' ||
        option.selectedCaseType === CaseType.phone_call_scheduled ||
        option.selectedCaseType === CaseType.oral_health_coaching
      ) {
        if (option.selectedCaseType === 'video_call_instant') {
          const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: 'video_call_instant' } }];
          dispatch(setForm(formPayload));
          roleNavigateWithStaffIntake('/select-needs', {
            state: {
              caseType: 'video_call_instant',
              userOrganization: organizationId,
              patientId: selectedPatient?.id,
            },
          });
        } else if (option.selectedCaseType === 'video_call_scheduled') {
          const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: 'video_call_scheduled' } }];
          dispatch(setForm(formPayload));
          roleNavigateWithStaffIntake('/select-date-time', {
            state: {
              caseType: 'video_call_scheduled',
              userOrganization: organizationId,
              patientId: selectedPatient?.id,
            },
          });
        } else if (option.selectedCaseType === CaseType.phone_call_scheduled) {
          const formPayload: FormValues[] = [
            { form_question_id: 20, value: { caseType: CaseType.phone_call_scheduled } },
          ];
          dispatch(setForm(formPayload));
          roleNavigateWithStaffIntake('/select-date-time', {
            state: {
              caseType: CaseType.phone_call_scheduled,
              userOrganization: organizationId,
              patientId: selectedPatient?.id,
            },
          });
        } else if (option.selectedCaseType === CaseType.oral_health_coaching) {
          const formPayload: FormValues[] = [
            { form_question_id: 20, value: { caseType: CaseType.oral_health_coaching } },
          ];
          dispatch(setForm(formPayload));
          const ohcState = {
            caseType: CaseType.oral_health_coaching as const,
            userOrganization: organizationId,
            patientId: selectedPatient?.id,
            patientState: selectedPatientLocationState,
          };
          if (isPaymentRequired) {
            roleNavigateWithStaffIntake('/payment-information', {
              state: { ...ohcState, afterPaymentRoute: '/select-care-advisor' as const },
            });
          } else {
            roleNavigateWithStaffIntake('/select-date-time', { state: ohcState });
          }
        }
      } else if (option.selectedCaseType === CaseType.care_coordination) {
        const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: CaseType.care_coordination } }];
        dispatch(setForm(formPayload));
        if (!isPaymentRequired) {
          const res = await createCaseForThisRequirement();
          if (res) setSubmitCCConfirmation(!submitCCConfirmation);
        } else {
          roleNavigateWithStaffIntake('/payment-information', {
            state: {
              caseType: CaseType.care_coordination,
              patientState: selectedPatientLocationState,
              userOrganization: organizationId,
              patientId: selectedPatient?.id,
            },
          });
        }
      } else if (option.selectedCaseType === 'one_report') {
        const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: 'one_report' } }];
        dispatch(setForm(formPayload));
        const oneReportState = {
          caseType: 'one_report' as const,
          patientState: selectedPatientLocationState,
          userOrganization: organizationId,
          patientId: selectedPatient?.id,
        };
        if (isPaymentRequired) {
          roleNavigateWithStaffIntake('/payment-information', {
            state: { ...oneReportState, afterPaymentRoute: '/clinical-data' as const },
          });
        } else {
          roleNavigateWithStaffIntake('/clinical-data', { state: oneReportState });
        }
      } else if (option.selectedCaseType === 'second_opinion') {
        const formPayload: FormValues[] = [
          {
            form_question_id: 15,
            value: {
              dental_emergency: 'no',
              sensitive_teeth: 'no',
              second_opinion: 'yes',
              improve_smile: 'no',
              improve_gum_health: 'no',
              grind_teeth_or_snore: 'no',
              something_else: 'no',
            },
          },
          {
            form_question_id: 16,
            value: { inPain: 'no', describePain: ['dull'], painLevel: 'noPain', daysInPain: '' },
          },
          { form_question_id: 20, value: { caseType: 'second_opinion' } },
        ];
        dispatch(setForm(formPayload));
        const secondOpinionState = {
          caseType: 'second_opinion' as const,
          patientState: selectedPatientLocationState,
          userOrganization: organizationId,
          patientId: selectedPatient?.id,
        };
        if (isPaymentRequired) {
          roleNavigateWithStaffIntake('/payment-information', {
            state: { ...secondOpinionState, afterPaymentRoute: '/clinical-data' as const },
          });
        } else {
          roleNavigateWithStaffIntake('/clinical-data', { state: secondOpinionState });
        }
      }
    } else if (
      customizeUserOrganization.length === 1 &&
      option.selectedCaseType !== 'back' &&
      selectedOrganization !== '' &&
      userInfo.role.name !== UserRoleName.OrganizationAdmin
    ) {
      await checkExternalForms();
      if (
        option.selectedCaseType === 'video_call_instant' ||
        option.selectedCaseType === 'video_call_scheduled' ||
        option.selectedCaseType === CaseType.phone_call_scheduled ||
        option.selectedCaseType === CaseType.oral_health_coaching
      ) {
        if (option.selectedCaseType === 'video_call_instant') {
          const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: 'video_call_instant' } }];
          dispatch(setForm(formPayload));
          roleNavigateWithStaffIntake('/select-needs', {
            state: {
              caseType: 'video_call_instant',
              userOrganization: organizationId,
              patientId: selectedPatient?.id,
            },
          });
        } else if (option.selectedCaseType === 'video_call_scheduled') {
          const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: 'video_call_scheduled' } }];
          dispatch(setForm(formPayload));
          roleNavigateWithStaffIntake('/select-date-time', {
            state: {
              caseType: 'video_call_scheduled',
              userOrganization: organizationId,
              patientId: selectedPatient?.id,
            },
          });
        } else if (option.selectedCaseType === CaseType.oral_health_coaching) {
          const formPayload: FormValues[] = [
            { form_question_id: 20, value: { caseType: CaseType.oral_health_coaching } },
          ];
          dispatch(setForm(formPayload));
          const ohcState = {
            caseType: CaseType.oral_health_coaching as const,
            userOrganization: organizationId,
            patientId: selectedPatient?.id,
            patientState: selectedPatientLocationState,
          };
          if (isPaymentRequired) {
            roleNavigateWithStaffIntake('/payment-information', {
              state: { ...ohcState, afterPaymentRoute: '/select-care-advisor' as const },
            });
          } else {
            roleNavigateWithStaffIntake('/select-date-time', { state: ohcState });
          }
        } else {
          const formPayload: FormValues[] = [
            { form_question_id: 20, value: { caseType: CaseType.phone_call_scheduled } },
          ];
          dispatch(setForm(formPayload));
          roleNavigateWithStaffIntake('/select-date-time', {
            state: {
              caseType: CaseType.phone_call_scheduled,
              userOrganization: organizationId,
              patientId: selectedPatient?.id,
            },
          });
        }
      } else if (option.selectedCaseType === CaseType.care_coordination) {
        const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: CaseType.care_coordination } }];
        dispatch(setForm(formPayload));
        if (!isPaymentRequired) {
          const res = await createCaseForThisRequirement();
          if (res) setSubmitCCConfirmation(!submitCCConfirmation);
        } else {
          roleNavigateWithStaffIntake('/payment-information', {
            state: {
              caseType: CaseType.care_coordination,
              patientState: selectedPatientLocationState,
              userOrganization: organizationId,
              patientId: selectedPatient?.id,
            },
          });
        }
      } else if (option.selectedCaseType === 'one_report') {
        const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: 'one_report' } }];
        dispatch(setForm(formPayload));
        const oneReportState = {
          caseType: 'one_report' as const,
          patientState: selectedPatientLocationState,
          userOrganization: organizationId,
          patientId: selectedPatient?.id,
        };
        if (isPaymentRequired) {
          roleNavigateWithStaffIntake('/payment-information', {
            state: { ...oneReportState, afterPaymentRoute: '/clinical-data' as const },
          });
        } else {
          roleNavigateWithStaffIntake('/clinical-data', { state: oneReportState });
        }
      } else if (option.selectedCaseType === 'second_opinion') {
        const formPayload: FormValues[] = [
          {
            form_question_id: 15,
            value: {
              dental_emergency: 'no',
              sensitive_teeth: 'no',
              second_opinion: 'yes',
              improve_smile: 'no',
              improve_gum_health: 'no',
              grind_teeth_or_snore: 'no',
              something_else: 'no',
            },
          },
          {
            form_question_id: 16,
            value: { inPain: 'no', describePain: ['dull'], painLevel: 'noPain', daysInPain: '' },
          },
          { form_question_id: 20, value: { caseType: 'second_opinion' } },
        ];
        dispatch(setForm(formPayload));
        const secondOpinionState = {
          caseType: 'second_opinion' as const,
          patientState: selectedPatientLocationState,
          userOrganization: organizationId,
          patientId: selectedPatient?.id,
        };
        if (isPaymentRequired) {
          roleNavigateWithStaffIntake('/payment-information', {
            state: { ...secondOpinionState, afterPaymentRoute: '/clinical-data' as const },
          });
        } else {
          roleNavigateWithStaffIntake('/clinical-data', { state: secondOpinionState });
        }
      }
    } else {
      // Catch-all for everyone the two branches above don't cover, most notably
      // non-OrgAdmin staff (e.g. CareAdvisor) whose patient has zero organizations
      // on record (customizeUserOrganization.length === 0). Without this, selectCaseType
      // silently returned here with no navigation and no case created, which read as
      // getting bounced back to the case-type step, most visibly after dismissing the
      // duplicate-consultation modal via "Create New Consultation".
      await checkExternalForms();
      if (
        option.selectedCaseType === 'video_call_instant' ||
        option.selectedCaseType === 'video_call_scheduled' ||
        option.selectedCaseType === CaseType.phone_call_scheduled ||
        option.selectedCaseType === CaseType.oral_health_coaching
      ) {
        if (option.selectedCaseType === 'video_call_instant') {
          const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: 'video_call_instant' } }];
          dispatch(setForm(formPayload));
          roleNavigateWithStaffIntake('/select-needs', {
            state: {
              caseType: 'video_call_instant',
              userOrganization: userInfo.organizations?.[0]?.id ?? organizationId,
              patientId: selectedPatient?.id,
            },
          });
        } else if (option.selectedCaseType === 'video_call_scheduled') {
          const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: 'video_call_scheduled' } }];
          dispatch(setForm(formPayload));
          roleNavigateWithStaffIntake('/select-date-time', {
            state: {
              caseType: 'video_call_scheduled',
              userOrganization: userInfo.organizations?.[0]?.id ?? organizationId,
              patientId: selectedPatient?.id,
            },
          });
        } else if (option.selectedCaseType === CaseType.oral_health_coaching) {
          const formPayload: FormValues[] = [
            { form_question_id: 20, value: { caseType: CaseType.oral_health_coaching } },
          ];
          dispatch(setForm(formPayload));
          const ohcOrgId = organizationId;
          const ohcState = {
            caseType: CaseType.oral_health_coaching as const,
            userOrganization: ohcOrgId,
            patientId: selectedPatient?.id,
            patientState: selectedPatientLocationState,
          };
          if (isPaymentRequired) {
            roleNavigateWithStaffIntake('/payment-information', {
              state: { ...ohcState, afterPaymentRoute: '/select-care-advisor' as const },
            });
          } else {
            roleNavigateWithStaffIntake('/select-date-time', { state: ohcState });
          }
        } else {
          const formPayload: FormValues[] = [
            { form_question_id: 20, value: { caseType: CaseType.phone_call_scheduled } },
          ];
          dispatch(setForm(formPayload));
          roleNavigateWithStaffIntake('/select-date-time', {
            state: {
              caseType: CaseType.phone_call_scheduled,
              userOrganization: userInfo.organizations?.[0]?.id ?? organizationId,
              patientId: selectedPatient?.id,
            },
          });
        }
      } else if (option.selectedCaseType === CaseType.care_coordination) {
        const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: CaseType.care_coordination } }];
        dispatch(setForm(formPayload));
        if (!isPaymentRequired) {
          const res = await createCaseForThisRequirement();
          if (res) setSubmitCCConfirmation(!submitCCConfirmation);
        } else {
          roleNavigateWithStaffIntake('/payment-information', {
            state: {
              caseType: CaseType.care_coordination,
              patientState: selectedPatientLocationState,
              userOrganization: organizationId,
              patientId: selectedPatient?.id,
            },
          });
        }
      } else if (option.selectedCaseType === 'one_report') {
        const formPayload: FormValues[] = [{ form_question_id: 20, value: { caseType: 'one_report' } }];
        dispatch(setForm(formPayload));
        const oneReportOrgState = {
          caseType: 'one_report' as const,
          patientState: selectedPatientLocationState,
          userOrganization: userInfo.organizations?.[0]?.id ?? organizationId,
          patientId: selectedPatient?.id,
        };
        if (isPaymentRequired) {
          roleNavigateWithStaffIntake('/payment-information', {
            state: { ...oneReportOrgState, afterPaymentRoute: '/clinical-data' as const },
          });
        } else {
          roleNavigateWithStaffIntake('/clinical-data', { state: oneReportOrgState });
        }
      } else if (option.selectedCaseType === 'second_opinion') {
        const formPayload: FormValues[] = [
          {
            form_question_id: 15,
            value: {
              dental_emergency: 'no',
              sensitive_teeth: 'no',
              second_opinion: 'yes',
              improve_smile: 'no',
              improve_gum_health: 'no',
              grind_teeth_or_snore: 'no',
              something_else: 'no',
            },
          },
          {
            form_question_id: 16,
            value: { inPain: 'no', describePain: ['dull'], painLevel: 'noPain', daysInPain: '' },
          },
          { form_question_id: 20, value: { caseType: option.selectedCaseType } },
        ];
        dispatch(setForm(formPayload));
        const secondOpinionOrgState = {
          caseType: 'second_opinion' as const,
          patientState: selectedPatientLocationState,
          userOrganization: userInfo.organizations?.[0]?.id ?? organizationId,
          patientId: selectedPatient?.id,
        };
        if (isPaymentRequired) {
          roleNavigateWithStaffIntake('/payment-information', {
            state: { ...secondOpinionOrgState, afterPaymentRoute: '/clinical-data' as const },
          });
        } else {
          roleNavigateWithStaffIntake('/clinical-data', { state: secondOpinionOrgState });
        }
      }
    }
    setLoadingUntillGetUserInfo(false);
  };

  const handleOptionClick = async (...args: Parameters<typeof selectCaseType>): Promise<void> => {
    try {
      await selectCaseType(...args);
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      setLoadingUntillGetUserInfo(false);
    }
  };

  const goBackToPatientProfile = useCallback(() => {
    if (isCollectorCaseCreation) {
      roleNavigateWithStaffIntake('/case-creation/patient/select');
      return;
    }
    if (userInfo.role.name === UserRoleName.CareAdvisor) {
      dispatch(setStaffIntakeInProgress(false));
      baseRoleNavigate('/patient-select');
      return;
    }

    const id = userId ?? selectedPatient?.id;
    const roleSegment = routeRole ?? selectedPatient?.role?.name;
    if (id != null && roleSegment) {
      navigate(`${reviewProfileBasePath}/${roleSegment}/${id}`);
    }
  }, [
    isCollectorCaseCreation,
    navigate,
    reviewProfileBasePath,
    roleNavigateWithStaffIntake,
    routeRole,
    selectedPatient?.id,
    selectedPatient?.role?.name,
    userInfo.role.name,
    userId,
  ]);

  if (loadingUntillGetUserInfo) {
    if (isUnifiedStaffIntakeMode) {
      return (
        <CollectorCaseCreationLayout progress={COLLECTOR_CASE_CREATION_PROGRESS} onExit={handleCollectorExit}>
          <div className={styles.collectorCcLoadingWrap}>
            <Loading dotted isHeightAuto />
          </div>
        </CollectorCaseCreationLayout>
      );
    }
    return (
      <Container
        patientDashboard
        isVisibleOnMobile={false}
        childClassName={caLayoutStyles.ccDashboard}
        containerStyle={{ overflowY: 'hidden' }}
        childrenStyle={{
          alignItems: 'flex-start',
          width: '100%',
        }}
      >
        <div className={caLayoutStyles.dashboardLayout}>
          <div className={caLayoutStyles.contentArea}>
            <Loading dotted isHeightAuto />
          </div>
        </div>
      </Container>
    );
  }

  const nextDisabled =
    selectedOrganization === '' ||
    selectedCase.selectedCaseType === '' ||
    loadingCalculation ||
    selectedState === '' ||
    caseOptions.length === 0 ||
    loadingUntillGetUserInfo;

  const mainForm = (
    <>
      <div className={styles.createConsultationForContainer}>
        <div
          className={`${styles.createConsultationFor} ${
            isUnifiedStaffIntakeMode ? styles.collectorCcConsultationForm : ''
          }`}
        >
          {isUnifiedStaffIntakeMode ? (
            <div className={styles.collectorCcAlert} role="status">
              <InfoIcon className={styles.collectorCcAlertIcon} aria-hidden />
              <div className={styles.collectorCcAlertText}>
                <p className={styles.collectorCcAlertTitle}>Creating new case</p>
                <p className={styles.collectorCcAlertDescription}>
                  You are currently creating a case for {selectedPatient?.full_name ?? 'this patient'}
                </p>
              </div>
            </div>
          ) : (
            <>
              <h1>Create a Consultation for</h1>
              <span className={styles.backSpan}>
                <button type="button" className={styles.backButton} onClick={goBackToPatientProfile}>
                  <MdKeyboardArrowLeft />
                  Back
                </button>
              </span>
              <span className={styles.br} />
              <div className={styles.patientInfo}>
                <div className={styles.leftDiv}>
                  <span>
                    <img
                      alt="Avatar"
                      onError={(event: any) => {
                        const img = event.target;
                        img.onError = null;
                      }}
                      className={styles.caImage}
                      src={getUserAvatar(Number(selectedPatient?.id))}
                    />
                  </span>
                  <span className={styles.patientInfoName}>
                    <span className={styles.title}>Name</span>
                    <span className={styles.value}>{selectedPatient?.full_name}</span>
                  </span>
                </div>
                <div className={styles.rightDiv}>
                  <span className={styles.patientInfoName}>
                    <span className={styles.title}>Address</span>
                    {pharmacyAddress !== '' && <span className={styles.value}>{pharmacyAddress}</span>}
                  </span>
                </div>
              </div>
            </>
          )}

          <div className={isUnifiedStaffIntakeMode ? styles.collectorCcSection : styles.selectContainerDiv}>
            {isUnifiedStaffIntakeMode ? (
              <>
                <div className={styles.collectorCcH5Row}>
                  <h2 className={styles.collectorCcH5}>Where will the patient be during the case?</h2>
                  <span className={styles.collectorCcRequired} aria-hidden>
                    *
                  </span>
                </div>
                <SelectInput
                  name="state"
                  options={stateOptions}
                  containerClass={styles.collectorCcSelectWrap}
                  selectorClass={styles.selector}
                  style={collectorStateSelectStyles}
                  placeholder="Select state *"
                  selectedValue={selectedState}
                  onChange={(value) => {
                    const nextState = value?.value || '';
                    setHasSelectedPatientLocationState(true);
                    setSelectedState(nextState);
                    if (selectedPatient?.id && nextState) {
                      dispatch(setPatientState({ userId: selectedPatient.id, state: nextState }));
                    }
                  }}
                />
              </>
            ) : (
              <>
                <div>
                  <div className={styles.caption}>Select patient state at time of consultation</div>
                  <SelectInput
                    name="state"
                    options={stateOptions}
                    containerClass={styles.inputWrapper}
                    selectorClass={styles.selector}
                    style={selectCommonCustomStylesSlim}
                    selectedValue={selectedState}
                    onChange={(value) => {
                      const nextState = value?.value || '';
                      setHasSelectedPatientLocationState(true);
                      setSelectedState(nextState);
                      if (selectedPatient?.id && nextState) {
                        dispatch(setPatientState({ userId: selectedPatient.id, state: nextState }));
                      }
                      if (selectedOrganization !== '') {
                        void calculateCreateCaseOption(selectedOrganization, nextState);
                      }
                    }}
                  />
                </div>
                <div>
                  <div className={styles.caption}>Select an Organization</div>
                  <SelectInput
                    name="organizations"
                    options={organizationOptions}
                    containerClass={styles.inputWrapper}
                    selectorClass={styles.selector}
                    style={selectCommonCustomStylesSlim}
                    selectedValue={selectedOrganization}
                    onChange={(value) => {
                      setSelectedOrganization(value?.value);
                      void calculateCreateCaseOption(value?.value, selectedState as string);
                    }}
                  />
                </div>
              </>
            )}
          </div>

          {loadingCalculation ? (
            <span className={isUnifiedStaffIntakeMode ? styles.collectorCcLoadingBlock : styles.loadingSpan}>
              <Loading dotted />
            </span>
          ) : selectedState !== '' && selectedOrganization !== '' && caseOptions && caseOptions.length > 0 ? (
            isUnifiedStaffIntakeMode ? (
              <div className={styles.collectorCcSection}>
                <div className={styles.collectorCcH5Row}>
                  <h2 className={styles.collectorCcH5}>Choose a case type</h2>
                  <span className={styles.collectorCcRequired} aria-hidden>
                    *
                  </span>
                </div>
                <div className={styles.collectorCcCaseGrid}>
                  {caseOptions.map(
                    ({
                      case_type,
                      amount,
                      payment_options,
                      amount_after_plan,
                      plan_decision_reason,
                      plan_free_remaining,
                    }) => {
                      if (case_type === '') return null;

                      const baseDollars = amount / 100;
                      const supportsInsurance = (payment_options || []).includes('Insurance');

                      const coveredByPlan =
                        supportsInsurance &&
                        amount_after_plan === 0 &&
                        (plan_decision_reason === 'FREE_ALLOWANCE' ||
                          plan_decision_reason === 'UNLIMITED' ||
                          plan_decision_reason == null) &&
                        (plan_decision_reason === 'UNLIMITED' || (plan_free_remaining ?? 0) > 0);

                      const hasAfterPlan = amount_after_plan !== null && amount_after_plan !== undefined;
                      const displayCents = hasAfterPlan ? amount_after_plan! : amount;
                      const displayDollars = displayCents / 100;

                      const formatMoney = (n: number): string => (n === 0 ? '' : `$${n.toFixed(2)}`);

                      const formattedPrice = hasAfterPlan
                        ? amount_after_plan === 0
                          ? coveredByPlan
                            ? "Covered by patient's plan"
                            : '$0'
                          : formatMoney(displayDollars)
                        : coveredByPlan
                        ? "Covered by patient's plan"
                        : formatMoney(baseDollars);

                      const isSelected = case_type === selectedCase.selectedCaseType;
                      return (
                        <button
                          key={case_type}
                          type="button"
                          className={`${styles.collectorCcCaseBtn} ${
                            isSelected ? styles.collectorCcCaseBtnSelected : ''
                          }`}
                          onClick={() =>
                            setSelectedCase({
                              selectedCaseType: case_type,
                              selectedCasePrice: (amount / 100).toString(),
                            })
                          }
                        >
                          <span className={styles.collectorCcCaseBtnLabel}>
                            <span>{getFriendlyName(case_type)}</span>
                            {formattedPrice ? <span>{formattedPrice}</span> : null}
                          </span>
                        </button>
                      );
                    },
                  )}
                </div>
              </div>
            ) : (
              <div className={styles.casesTypeContainer}>
                <div className={styles.caption}>Choose a consultation type</div>
                <div className={styles.caseSpan}>
                  {caseOptions.map(
                    (
                      {
                        case_type,
                        amount,
                        payment_options,
                        amount_after_plan,
                        plan_decision_reason,
                        plan_free_remaining,
                      },
                      index,
                    ) => {
                      const baseDollars = amount / 100;
                      const supportsInsurance = (payment_options || []).includes('Insurance');

                      const coveredByPlan =
                        supportsInsurance &&
                        amount_after_plan === 0 &&
                        (plan_decision_reason === 'FREE_ALLOWANCE' ||
                          plan_decision_reason === 'UNLIMITED' ||
                          plan_decision_reason == null) &&
                        (plan_decision_reason === 'UNLIMITED' || (plan_free_remaining ?? 0) > 0);

                      const hasAfterPlan = amount_after_plan !== null && amount_after_plan !== undefined;
                      const displayCents = hasAfterPlan ? amount_after_plan! : amount;
                      const displayDollars = displayCents / 100;

                      const formatMoney = (n: number): string => (n === 0 ? '' : `$${n.toFixed(2)}`);

                      const formattedPrice = hasAfterPlan
                        ? amount_after_plan === 0
                          ? coveredByPlan
                            ? "Covered by patient's plan"
                            : '$0'
                          : formatMoney(displayDollars)
                        : coveredByPlan
                        ? "Covered by patient's plan"
                        : formatMoney(baseDollars);

                      return (
                        case_type !== '' && (
                          <span
                            key={index}
                            onClick={() =>
                              setSelectedCase({
                                selectedCaseType: case_type,
                                selectedCasePrice: (amount / 100).toString(),
                              })
                            }
                            className={case_type === selectedCase.selectedCaseType ? styles.selected : ''}
                          >
                            {getFriendlyName(case_type)}
                            {formattedPrice ? ` - ${formattedPrice}` : ''}
                          </span>
                        )
                      );
                    },
                  )}
                </div>
              </div>
            )
          ) : selectedState !== '' && selectedOrganization !== '' && caseOptions && caseOptions.length === 0 ? (
            <div className={isUnifiedStaffIntakeMode ? styles.collectorCcSection : styles.casesTypeContainer}>
              <div className={isUnifiedStaffIntakeMode ? styles.collectorCcAlertDescription : styles.caption}>
                No consultation found
              </div>
            </div>
          ) : null}

          {isUnifiedStaffIntakeMode ? (
            <div className={styles.collectorCcFooter}>
              <button type="button" className={styles.collectorCcBackLink} onClick={goBackToPatientProfile}>
                <MdKeyboardArrowLeft aria-hidden />
                Back
              </button>
              <Button
                type="button"
                className={styles.collectorCcNextBtn}
                disabled={nextDisabled}
                onClick={() => handleOptionClick(selectedOrganization, selectedCase)}
              >
                {!(
                  selectedCase.selectedCaseType === CaseType.care_coordination && selectedCase.selectedCasePrice === '0'
                )
                  ? 'Next'
                  : 'Finish'}
              </Button>
            </div>
          ) : (
            <div className={styles.btnContainer}>
              <Button
                type="button"
                disabled={nextDisabled}
                onClick={() => handleOptionClick(selectedOrganization, selectedCase)}
              >
                {!(
                  selectedCase.selectedCaseType === CaseType.care_coordination && selectedCase.selectedCasePrice === '0'
                )
                  ? 'Next'
                  : 'Finish'}
              </Button>
            </div>
          )}
        </div>
      </div>

      <OpenCaseListModal
        isOpen={openCasesModal}
        toggleModal={toggleOpenCasesModal}
        openCases={openCases}
        orgId={orgId}
        selectedCase={selectedCase}
        handleOptionClick={handleOptionClick}
      />
      {submitCCConfirmation && <SubmitCCConfirmationModal />}
    </>
  );

  if (isUnifiedStaffIntakeMode) {
    return (
      <CollectorCaseCreationLayout progress={COLLECTOR_CASE_CREATION_PROGRESS} onExit={handleCollectorExit}>
        {mainForm}
      </CollectorCaseCreationLayout>
    );
  }

  return (
    <Container
      patientDashboard
      isVisibleOnMobile={false}
      childClassName={caLayoutStyles.ccDashboard}
      containerStyle={{ overflowY: 'hidden' }}
      childrenStyle={{
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <div className={caLayoutStyles.dashboardLayout}>
        <div className={caLayoutStyles.contentArea}>{mainForm}</div>
      </div>
    </Container>
  );
};

export default CreateConsultationFor;
